module.exports = __webpack_public_path__ + "static/media/warning.71237d93.mp3";